import {Repository} from "@api/repositories/Repository";
import {AxiosInstance} from "axios";
import {QueryParametersInterface} from "@api/repositories/interfaces/QueryParametersInterface";
import {Form} from "../models/Form";
import {FormInterface} from "../models/interfaces/FormInterface";

export class FormsRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    list(params: QueryParametersInterface) {
        return this.client.post('/v2/forms/list/query', params)
            .then(({data}) => {
                return data.map((item: FormInterface) => new Form(item));
            });
    }
}